<template>
  <div>
    <identity-verification-form
      :form-model="formModel"
      :person-title="locale.interestParty.tabTitle"
      :view-mode="loading"
      :manager-social-id-required="false"
      :request-owner-type-id="requestOwnerTypeId"
      :main-request-details-types="mainRequestDetailsTypesEnum.interestedParties"
      :is-edit-mode="isEditMode"
      @isIdentityVerified="$emit('isIdentityVerified', $event)"
    >
      <template slot="interestedParty">
        <v-row>
          <v-col
            v-if="showMobileField"
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.bankruptDebts.mobile"
              :value.sync="formModel.mobile"
              :required="true"
              :validates="`required|numeric|phone|digits:10`"
              :disabled="isViewMode || isEditMode || loading"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.bankruptDebts.email"
              :value.sync="formModel.email"
              :required="true"
              :validates="`required|email`"
              :disabled="isViewMode || isEditMode || loading"
            ></naj-input>
          </v-col>
          
          <v-col
            cols="12"
            md="6"
            lg="3"
            v-if="isForeignCompany"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="locale.bankruptDebts.countryId"
              :value.sync="formModel.countryId"
              :value-name.sync="formModel.countryName"
              :items="countries"
              item-text="name"
              item-value="id"
              validates="required"
              :disabled="!countries.length || isViewMode || isEditMode || loading"
              @change="countryChanged"
            ></naj-input>
          </v-col>
          <v-col
            v-if="(cities || []).length != 0 && isForeignCompany"
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="locale.bankruptDebts.cityId"
              :value.sync="formModel.cityId"
              :value-name.sync="formModel.cityName"
              :items="cities"
              item-text="name"
              item-value="id"
              validates="required"
              :disabled="isViewMode || isEditMode || loading"
            ></naj-input>
          </v-col>
          <v-col
            v-else-if="isForeignCompany"
            cols="12"
            md="6"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.bankruptDebts.cityId"
              :value.sync="formModel.cityName"
              :disabled="isViewMode || isEditMode || loading"
              validates="required"
            ></naj-input>
          </v-col>
        </v-row>
      </template>
    </identity-verification-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions, mapGetters } = createNamespacedHelpers('BankruptcyModule');
import IdentityVerificationForm from '../../../identity-verification-form.vue';
import { mainRequestDetailsTypesEnum, partyTypeEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  inject: ['$validator'],
  components: { IdentityVerificationForm },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    isEditMode: {
      type: Boolean,
      required: false,
    },
    requestOwnerTypeId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      mainRequestDetailsTypesEnum,
      partyTypeEnum,
    };
  },
  computed: {
    ...mapState(['countries', 'countryCities']),
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isNotCompleted',
    ]),
    cities() {
      return this.countryCities[this.formModel.countryId];
    },
    showMobileField() {
      // Hide mobile field for foreign companies (similar to creditor form)
      return this.formModel.typeId !== partyTypeEnum.foreignCompany;
    },
    isForeignCompany() {
      return this.formModel.typeId === partyTypeEnum.foreignCompany;
    },
  },
  watch: {
    'formModel.countryId'(newValue) {
      this.getCountryCities(newValue);
    },
    'formModel.typeId'() {
      // Reset mobile field when type changes to foreign company
      if (this.formModel.typeId === partyTypeEnum.foreignCompany) {
        this.$set(this.formModel, 'mobile', null);
      }
    },
  },
  created() {
    this.getCountries();
  },
  methods: {
    ...mapActions(['getCountries', 'getCountryCities']),
    countryChanged(value) {
      if (value) {
        this.getCountryCities(value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


